/** id для текстов с динамическим количеством блоков для боковой навигации */
export const dynamicTextIdTemplate = (index: number) => `info_text${index}`;
